import { useMutation } from "react-query";
import getSNOfferRoom from "../services/getOfferRoom";


const useOfferRoom = () => {
    return useMutation(["offer-room"], getSNOfferRoom);
  };

export default useOfferRoom;